import { Col, Text } from 'components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Paragraph = (props) => <Text marg="39px 0 0" {...props} />;

const PrivacyPolicy = ({}) => {
  const { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Col wid="100vw" center>
      <Col noFlex wid={isMobile ? 'calc(100vw - 32px)' : '1140px'} center>
        <Paragraph h1 wid="100%" center>
          Privacy Policy
        </Paragraph>

        <Paragraph marg="15px 0 0">
          Playaz4Playaz LLC ("us", "we", "our") complies with the Singapore Personal Data Protection
          Act 2012 (“the Act”) and other applicable privacy and data protection laws when dealing
          with Personal Data. This privacy policy ("policy") will help you understand how uses and
          protects the Personal Data (as described in the Act), is being used (“Personal Data”) you
          provide to us when you visit and use Playaz4Playaz.com ("website", "services"). Personal
          Data is information about an identifiable individual (a natural person) that can be used
          on its own or combined with other information to identify an individual.
        </Paragraph>

        <Paragraph>
          By registering for, downloading, or using our services, you accept this Privacy Policy,
          which is part of our Terms of Service.
        </Paragraph>

        <Paragraph>
          We reserve the right to change this policy at any given time. We will post any modified
          version of our Privacy Policy at{' '}
          <a href="https://playaz4playaz.com/privacy-policy">
            {'https://playaz4playaz.com/privacy-policy'}
          </a>{' '}
          . If we change the Privacy Policy in a way that materially lessens our commitments to you,
          we will provide notice to registered users by email or other methods. If you want to make
          sure that you are up to date with the latest changes, we advise you to frequently visit{' '}
          <a href="https://playaz4playaz.com/privacy-policy">
            {'https://playaz4playaz.com/privacy-policy'}
          </a>
          . Any change will apply from the date we upload the revised policy.
        </Paragraph>

        <Paragraph>
          This Privacy Policy does not limit or exclude any of your rights under the Act and other
          applicable laws. If you wish to seek further information on the Act, see
          https://www.pdpc.gov.sg/overview-of-pdpa/the-legislation/personal-data-protection-act.
        </Paragraph>

        <Text h2 marg="34px 0 0">
          What Personal Data We Collect
        </Text>

        <Paragraph marg="15px 0 0">
          When you visit the website, we may collect, hold and process the following Personal Data:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              in connection with the creation or administration of a customer account
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">when you sign up to or access or use our services</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              when you contact us directly (e.g. website enquiry form, email, live chat features or
              through your user dashboard) or visit our website
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          The Personal Data we collect may include:
        </Text>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              your IP address and/or other device identifying data
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              your contact information (including your name, username, phone number, email address
              and any other contact information you provide to us)
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              our location, billing information, purchase history
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              other information such as interests and preferences
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              data profile regarding your online behavior on our website and other information about
              how you use our services or website (for example, traffic volumes, times spent on
              pages)
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Information contained in your correspondence with us or survey responses; and
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              Other information required to provide a service or information you have requested from
              us.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              We do not knowingly collect personal information from individuals who are under the
              minimum required ages specified herein. You must be at least 13 years old or the age
              of majority in your jurisdiction, whichever is greater, to use our services.
              Individuals under the applicable age may use our services only through a parent or
              legal guardian's account and with their involvement. If you are a parent or legal
              guardian who believes your child has provided personal information to Playaz4Playaz
              without your consent, you may ask us to delete such information by contacting us at{' '}
              <a href="https://playaz4playaz.com/privacy-policy">
                {'https://playaz4playaz.com/privacy-policy'}
              </a>
              .
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          Who do we collect your Personal Data from?
        </Text>

        <Paragraph marg="15px 0 0">We collect Personal Data about you from:</Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              you, when you provide that Personal Data to us, including via our website and services
              through any registration, subscription or purchase process on our website, through any
              contact with us (including Live Chat or email), by entering information on our website
              in any other way, or by providing us with feedback on our products or services
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              third parties where you have authorised this (e.g. from Stripe and Paypal where you
              process payments on Playaz4Playaz. If you submit Personal Data to Stripe and Paypal,
              use of your Personal Data will be subject to their privacy policies)). If possible, we
              will collect Personal Data from you directly
            </Paragraph>
          </li>
        </ul>

        <Paragraph marg="15px 0 0">
          When you visit or use our website or services, we may collect information about you:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              by recording clickstream data, which is non-personal information that is recorded when
              you click anywhere on a webpage and is used for the purposes of collecting, analysing
              and reporting data about how you use our website and related services; and
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              through the use of cookies, web beacons and similar storage technologies (see more
              detail about our use of cookies below).
            </Paragraph>
          </li>
        </ul>

        <Text h2 marg="10px 0 0">
          How We Use Your Personal Data
        </Text>

        <Paragraph marg="15px 0 0">
          We may use your Personal Data for the following purposes:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Identification and authentication:</b> We use your Personal Data to verify your
              identity when you access your account.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Operating our services:</b> We use your Personal Data to better understand your
              needs and to provide our services, process and fulfill orders, provide customer
              support, and to otherwise comply with our contractual obligations to you. We (and/or
              our third-party vendors) use your financial information to process purchases made by
              you and to pay you amounts you may earn using the services.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Communicating with you:</b> We use your Personal Data when we communicate with you
              (e.g., when we respond to a customer support or other inquiry), and to fill out
              surveys and participate in other types of market research.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Improving our services:</b> We use your Personal Data to understand how our
              services are being used and how we can improve them. In general, we analyze anonymized
              aggregated data, rather than specific user data. We may, however, need to analyze a
              specific case to address a specific problem (e.g., a bug that affects only a few
              accounts).
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Customizing your experience:</b> We use your Personal Data to personalize the
              service to you. This may include remembering your preferences for language or volume
              or displaying content that you might enjoy, based upon your choices, or according to
              your online behavior and personal preferences.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Marketing and advertising:</b> We use your Personal Data to show you ads on
              third-party sites. We may also use your Personal Data to inform decisions when
              delivering third-party advertisements to you. This may include "targeted ads" based
              upon your activities.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Promotions:</b> We use your Personal Data to send you promotional emails containing
              the information we think you will find interesting, you can stop receiving our
              promotional emails by following the unsubscribe instruction included in those emails.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Exercising our rights:</b> Where reasonably necessary, we use your Personal Data to
              exercise our legal rights and prevent abuse of our service. For example, we may use
              your Personal Data to detect and prevent fraud, spam, or content that violates our
              Terms of Service.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Legal compliance:</b> We use your Personal Data where we are legally required to do
              so. For example, we may need to gather your Personal Data to respond to a subpoena or
              court order or to protect and/pr enforce our legal rights, including defending any
              claim, or to responds to lawful requests by public authorities or law enforcement.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Protecting your information:</b> Where appropriate, we may anonymize, backup, and
              delete certain Personal Data.
            </Paragraph>
          </li>
        </ul>

        <Paragraph marg="15px 0 0">
          We may use algorithms and other automated means to implement any of the above.
        </Paragraph>

        <Paragraph>
          Whenever we process your Personal Data for one of these purposes, we have determined that
          one or more of the following lawful bases apply:
        </Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">Performance of a contract;</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Legitimate commercial interest;</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Compliance with a legal obligation; or</Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">Your Consent</Paragraph>
          </li>
        </ul>

        <Paragraph marg="15px 0 0">
          If you require further information contact us at{' '}
          <a href="https://playaz4playaz.com/privacy-policy">
            {'https://playaz4playaz.com/privacy-policy'}
          </a>
          .
        </Paragraph>

        <Text h2 marg="25px 0 0">
          With Whom We Share Your Personal Data
        </Text>

        <Paragraph marg="15px 0 0">We share Personal Data with third parties as follows:</Paragraph>

        <ul>
          <li>
            <Paragraph marg="15px 0 0">
              <b>As you instruct:</b> We may make your profile and content available to others as
              you instruct in using our services. We may share your Personal Data with persons to
              whom you have granted account-level access.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>With your consent:</b> We may share your Personal Data with third parties where we
              have obtained your express consent to do so.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Authorized vendors:</b> We may share your Personal Data with third-party vendors
              that help us operate our services, process orders, and comply with your instructions
              and our contractual obligations. This includes payment processors, content delivery
              networks (CDNs), cloud-based hosting services, monitoring services, email service
              providers, quality assurance and testing vendors, fraud and abuse prevention vendors,
              customer relations management (CRM) vendors, and shipment vendors.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Advertising:</b> We may share your Personal Data with advertising companies to
              display relevant ads to you.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Analytics:</b> We may share your Personal Data on an aggregated anonymized basis
              with analytics providers which help us understand how customers are using our
              services.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Affiliates and advisors:</b> We may share your Personal Data with our parent
              company, Playaz4Playaz PTE. LTD., and our auditors and advisors for planning,
              financial reporting, accounting, auditing, tax filings, and legal compliance. We may
              share your Personal Data with our affiliates to the extent necessary to provide you
              with the services ordered.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Certain legal situations:</b> We may share your Personal Data where we believe
              disclosure is necessary to comply with a legal obligation or for safety related
              reasons.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Aggregated or anonymized information:</b> We may publicly disclose non-personal
              aggregated or anonymized information such as our number of visitors and registered
              users.
            </Paragraph>
          </li>
          <li>
            <Paragraph marg="15px 0 0">
              <b>Corporate transaction:</b> We may share your Personal Data with potential
              transaction partners, advisors, and others in the event our company is, in whole or
              part, acquired by a third party. In such case, we will use reasonable efforts to
              require the acquiring entity to comply with this Privacy Policy.
            </Paragraph>
          </li>
        </ul>

        <Paragraph marg="15px 0 0">
          We use reasonable efforts to vet vendors for their privacy and data security practices. We
          require that such vendors agree to protect the Personal Data we share.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Our Cookie Policy
        </Text>

        <Paragraph marg="20px 0 0">
          Once you agree to allow our website to use cookies, you also agree to our use of the
          Personal Data it collects regarding your online behavior (analyze web traffic, web pages
          you spend the most time on, and websites you visit).
        </Paragraph>

        <Paragraph marg="34px 0 0">
          The Personal Data we collect by using cookies is used to customize our website to your
          needs. After we use the Personal Data for statistical analysis, the data is deleted from
          our systems.
        </Paragraph>

        <Paragraph marg="34px 0 0">
          Please note that cookies don't allow us to gain control of your device in any way. They
          are strictly used to monitor your website activity so that we can provide a better
          experience for you.
        </Paragraph>

        <Paragraph marg="34px 0 0">
          If you want to disable cookies, you can do it by accessing the settings of your internet
          browser. If you choose to disable cookies, it may effect your ability to use certain
          features of the website.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Facebook Connect
        </Text>

        <Paragraph marg="20px 0 0">
          Facebook Connect or “Login with Facebook” allows Facebook users to use their Facebook
          accounts to create an account for, and log into, the services. If you choose to register
          an account to use the services using Facebook Connect, or later link your account with the
          service to your Facebook account using Facebook Connect, Facebook will ask your permission
          to share certain information from your Facebook account with us.
        </Paragraph>

        <Paragraph marg="34px 0 0">
          If you sign up to the services using Facebook Connect, your account with us will be
          automatically connected to your Facebook Account. We will use any Personal Data you may
          provide to Facebook (such as your name, email address and other information you made
          publicly available via Facebook) to create your account with the services.
        </Paragraph>

        <Paragraph marg="34px 0 0">
          The Personal Data we collect through your use of Facebook Connect will depend on the
          privacy setting you have with Facebook and the permissions you grant to us in connection
          with linking your account with the services to your Facebook account. We may add any
          Personal Data received through your use of Facebook Connect to the Personal Data we have
          already collected from your via the service, and we will treat any such Personal Data in
          accordance with this Privacy Policy.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Links to Other Websites
        </Text>

        <Paragraph marg="20px 0 0">
          Our website contains links that lead to other websites. If you click on these links
          Playaz4Playaz is not held responsible for your Personal Data and privacy protection.
          Visiting those websites is not governed by this Privacy Policy. Make sure to read the
          privacy policy documentation of the third party website.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Data Retention
        </Text>

        <Paragraph marg="20px 0 0">
          We retain your Personal Data for as long as you have an account. When you close an
          account, we will delete its content. We may retain logs of automatically collected
          information (for internal analytics and security purposes); your email address; your tax
          information; communications with you; and your transactional information (for auditing,
          tax, and financial purposes). When we no longer have a business reason for retaining data,
          we will delete or anonymize it.
        </Paragraph>

        <Paragraph>
          If we receive legal process pertaining to your account, we will retain your Personal Data
          for as long as we in good faith believe is necessary to comply with the legal process.
          Similarly, if we believe that your account has been involved in wrongdoing, we may
          preserve your Personal Data to defend or assert our rights.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Mobile Device Communications
        </Text>

        <Paragraph marg="20px 0 0">
          We may, with your consent, send push notifications in our apps. You may disable these by
          declining them or changing the app's settings. To the extent provided, we may, with your
          consent, send SMS messages to your mobile telephone for authentication and security
          purposes. You may opt out of receiving such messages at any time.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Protecting Your Personal Data
        </Text>

        <Paragraph marg="20px 0 0">
          Playaz4Playaz is committed to securing your Personal Data and keeping it in accordance
          with this Privacy Policy. Playaz4Playaz will use best commercial efforts to prevent
          Personal Data theft, unauthorized access, and disclosure by implementing the latest
          technologies and software, which help us safeguard all the Personal Data we collect.
        </Paragraph>

        <Paragraph marg="20px 0 0">
          We use physical, technical, and organizational security measures to safeguard your
          Personal Data from unauthorized or accidental disclosure. Despite these efforts, no
          information system can be 100% secure, so we cannot guarantee the absolute security of
          your information. Users also have a role to play in keeping their data safe. We encourage
          you to use a unique and hard-to-guess password for your account and to not share it with
          others. You should only grant access rights to people who you know and trust, and, even
          then, you should be careful in granting all access rights. You should monitor your account
          regularly. If you believe that someone has gained access to your account without your
          permission, please contact us immediately so that we can investigate.
        </Paragraph>

        <Paragraph marg="20px 0 0">
          You may receive other people's Personal Data in using our service. If you receive Personal
          Data from other users, you must comply with all laws, including those concerning privacy,
          data security, and online marketing.
        </Paragraph>

        <Text h2 marg="25px 0 0">
          International Data Transfers and Certain User Rights
        </Text>

        <Text h3 marg="25px 0 0">
          Location and Data
        </Text>

        <Paragraph marg="20px 0 0">
          We operate in the United States. We provide services globally using computer systems,
          servers, and databases located in the U.S. and other countries. When you use our services
          from outside of the U.S., your Personal Data may be transferred to and processed in the
          U.S. and other global data centers, depending on your region. Please note that U.S. data
          and privacy laws may not be as comprehensive as those in your country. Residents of
          certain countries may be subject to additional protections. as set forth below.
        </Paragraph>

        <Text h3 marg="25px 0 0">
          ‍Assessing and correcting your Personal Data
        </Text>

        <Paragraph marg="20px 0 0">
          Subject to certain grounds for refusal set out in the Act or other applicable law, you
          have the right to access your readily retrievable Personal Data that we hold and to
          request a correction to your Personal Data. Before you exercise this right, we will need
          evidence to confirm that you are the individual to whom the Personal Data relates.
        </Paragraph>

        <Paragraph marg="20px 0 0">
          In respect of a request for correction, if we think the correction is reasonable and we
          are reasonably able to change the Personal Data, we will make the correction. If we do not
          make the correction, we will take reasonable steps to note on the Personal Data that you
          requested the correction.
        </Paragraph>

        <Paragraph marg="20px 0 0">
          If you want to exercise either of the above rights, contact us at{' '}
          <a href="https://playaz4playaz.com/privacy-policy">
            {'https://playaz4playaz.com/privacy-policy'}
          </a>
          . You should provide evidence of who you are and set out the details of your request (e.g.
          the Personal Data, or the correction, that you are requesting).
        </Paragraph>

        <Text h2 marg="25px 0 0">
          Contact Us
        </Text>

        <Paragraph marg="10px 0 0">
          For any questions, inquiries, or complaints relating to your privacy, please contact us
          at:
        </Paragraph>

        <Paragraph>
          <i>Playaz4Playaz, LLC.</i>
        </Paragraph>

        <Paragraph marg="10px 0 0">
          <i>Attention: Data Protection Officer</i>
        </Paragraph>

        <Paragraph marg="10px 0 0">
          <a href="https://playaz4playaz.com/DMCA">{'https://playaz4playaz.com/DMCA'}</a>.
        </Paragraph>

        <Paragraph marg="10px 0 200px">Last updated: June 2021</Paragraph>
      </Col>
    </Col>
  );
};

export default PrivacyPolicy;
